/**
 * Скрипты для форм
 */
var simpleForm = function ($self) {
    var $form = $self.find('.js-form');
    var SUCCESS_CLASS = 'success';
    var ERROR_CLASS = 'has-error';


    /**
     * Показывает ошибки
     */
    var showErrors = function(formErrors) {
        Object.keys(formErrors)
            .forEach(function (field) {
                var $currentField = $form.find('[name=' + field + ']');

                $currentField
                    .closest('.js-form-group')
                    .addClass(ERROR_CLASS);

                $currentField.closest('.js-form-group').find('.js-block-error').show().text(formErrors[field]);
            });
    };

    /**
     * Очищаем ошибки
     */
    var clearErrors = function () {
        $form.find('.js-form-group').removeClass(ERROR_CLASS);
        $form.find('.js-form-group').find('.js-block-error').empty();
    };


    /**
     * Обработка отправки формы
     */
    $form.on('submit', function (e) {
        e.preventDefault();
        clearErrors();
        var crfToken = document.querySelector('meta[name="csrf-token"]').content;
        $form.find('input[name="_crf"]').val(crfToken);

        $.ajax({
            method: 'POST',
            url: $form.attr('action'),
            data: $form.serialize()
        }).done(function(data) {
            if (data.result === 'fail') {
                showErrors(data.errors);
                return;
            }
            $self.addClass(SUCCESS_CLASS);

        }).fail(function (error) {
            console.log(error);
        });
    });
};

